 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"0455cd687c25b198d3859d1fa80793dc0f70d737","2":"f96dc8d22804afa8df5b533b4e14e89e64fbf4cd","3":"34e3c50bfa9c80892cb455b17730b38c947774cb","4":"d52483855fd775339cc485a846e7ad06a7cffcba","5":"cd750e4f9837eb2d906dc4d15dea38b6dc496df2","7":"faaf5f18c95a91ee24dcc5f6fd01d664925e296d","13":"component---src-components-blog-blog-post-content-blog-post-content-tsx","14":"component---src-content-blog-allbright-five-payment-solutions-part-1-index-mdx","15":"component---src-content-blog-allbright-five-payment-solutions-part-2-index-mdx","16":"component---src-content-blog-allbright-five-payment-solutions-part-3-index-mdx","17":"component---src-content-blog-how-do-i-integrate-braintree-payments-into-my-flutter-mobile-app-index-mdx","18":"component---src-content-blog-webrtc-agora-integration-index-mdx","19":"component---src-content-blog-webrtc-mobile-sdk-agora-vs-quickblox-vs-twilio-index-mdx","20":"component---src-content-blog-webrtc-part-2-how-does-it-work-index-mdx","21":"component---src-content-blog-what-is-the-future-of-mobile-wallets-index-mdx","22":"component---src-content-blog-what-is-webrtc-part-1-benefits-index-mdx","23":"component---src-content-blog-whats-best-in-2021-ionic-react-native-or-flutter-index-mdx","24":"component---src-content-blog-why-is-flutter-so-effective-and-how-can-it-help-my-business-index-mdx","25":"component---src-pages-404-tsx","26":"component---src-pages-blog-tsx","27":"component---src-pages-contact-tsx","28":"component---src-pages-how-we-work-tsx","29":"component---src-pages-index-tsx","30":"component---src-pages-partners-entre-tsx","31":"component---src-pages-portfolio-case-study-captio-tsx","32":"component---src-pages-portfolio-case-study-fintech-connector-tsx","33":"component---src-pages-portfolio-case-study-kardiolog-tsx","34":"component---src-pages-portfolio-case-study-medrefer-tsx","35":"component---src-pages-portfolio-index-tsx","36":"component---src-pages-privacy-policy-tsx","37":"component---src-pages-services-flutter-app-development-index-tsx","38":"component---src-pages-services-health-wellbeing-medical-app-development-company-index-tsx","39":"component---src-pages-services-mobile-development-index-tsx"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"1db7e05109b04046286c","2":"93966b82b2d18d11a289","3":"7f178574f67659f62b92","4":"7a3cc07d193a23b605bd","5":"cd75f53793173d54b964","7":"2e9d3b28ea1fca79be9d","13":"02abd3e3072e842d7d94","14":"3d5b0438ba842ee395ac","15":"b2c9e864bbc1813fba61","16":"12445c8b05536eecb56c","17":"0c19c6b1cc94569c71e2","18":"6f40363e145e5c6d2e55","19":"c647b508e485b1cc7412","20":"1a0caaf0f68337e44271","21":"01cc4901b0b10956d7d7","22":"396baa03b699d84f76c4","23":"08e4a739ce274d4cb301","24":"fd964d6274e190d6448a","25":"3e20246821ef39ca77b4","26":"ff182c1af3d1b54ddd7d","27":"c778f1a2c0ac8bda11cd","28":"b04cbc33349e757f9e00","29":"c1f6a75d371d9975a511","30":"a7d591ce4a1b919f9778","31":"11e005ad5cd7c47a09c2","32":"73fd28f05a212a9fdf33","33":"f6281fc626962cde35bf","34":"479115f106f5949e3eb5","35":"732afede4861b64f8b5b","36":"27dd2a8fadbd77c194d7","37":"25cbca4f2d26db0dd42b","38":"44a19f8f9b61666051b2","39":"c40b3b3c03d273f89b1e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"0455cd687c25b198d3859d1fa80793dc0f70d737","2":"f96dc8d22804afa8df5b533b4e14e89e64fbf4cd","3":"34e3c50bfa9c80892cb455b17730b38c947774cb","4":"d52483855fd775339cc485a846e7ad06a7cffcba","5":"cd750e4f9837eb2d906dc4d15dea38b6dc496df2","7":"faaf5f18c95a91ee24dcc5f6fd01d664925e296d","13":"component---src-components-blog-blog-post-content-blog-post-content-tsx","14":"component---src-content-blog-allbright-five-payment-solutions-part-1-index-mdx","15":"component---src-content-blog-allbright-five-payment-solutions-part-2-index-mdx","16":"component---src-content-blog-allbright-five-payment-solutions-part-3-index-mdx","17":"component---src-content-blog-how-do-i-integrate-braintree-payments-into-my-flutter-mobile-app-index-mdx","18":"component---src-content-blog-webrtc-agora-integration-index-mdx","19":"component---src-content-blog-webrtc-mobile-sdk-agora-vs-quickblox-vs-twilio-index-mdx","20":"component---src-content-blog-webrtc-part-2-how-does-it-work-index-mdx","21":"component---src-content-blog-what-is-the-future-of-mobile-wallets-index-mdx","22":"component---src-content-blog-what-is-webrtc-part-1-benefits-index-mdx","23":"component---src-content-blog-whats-best-in-2021-ionic-react-native-or-flutter-index-mdx","24":"component---src-content-blog-why-is-flutter-so-effective-and-how-can-it-help-my-business-index-mdx","25":"component---src-pages-404-tsx","26":"component---src-pages-blog-tsx","27":"component---src-pages-contact-tsx","28":"component---src-pages-how-we-work-tsx","29":"component---src-pages-index-tsx","30":"component---src-pages-partners-entre-tsx","31":"component---src-pages-portfolio-case-study-captio-tsx","32":"component---src-pages-portfolio-case-study-fintech-connector-tsx","33":"component---src-pages-portfolio-case-study-kardiolog-tsx","34":"component---src-pages-portfolio-case-study-medrefer-tsx","35":"component---src-pages-portfolio-index-tsx","36":"component---src-pages-privacy-policy-tsx","37":"component---src-pages-services-flutter-app-development-index-tsx","38":"component---src-pages-services-health-wellbeing-medical-app-development-company-index-tsx","39":"component---src-pages-services-mobile-development-index-tsx"}[chunkId]||chunkId) + "." + {"0":"32d78a14e46a33a273a2","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
